import { cn } from '@/lib/utils'

/**
 * The one spinner in the console: a ring the size of the text beside it.
 *
 * Decorative by default - it is never the only thing saying something is in
 * flight, so it carries `aria-hidden` and the words next to it do the
 * announcing.
 */
export function Spinner({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-border border-t-mint',
        className
      )}
    />
  )
}
